module.exports = __webpack_public_path__ + "static/img/Section1.046df17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Section1.png
// module id = 6sw9
// module chunks = 1